import { useState } from "react";
import PropTypes from "prop-types";
import {
  Alert,
  Box,
  Typography,
  Paper,
  Button,
  TextField,
} from "@mui/material";
import HeaderLogo from "../common/HeaderLogo";
import superagent from "superagent";
import { apiUrl } from "../common/apiUrl";
import { defaults } from "./PasswordConstants";
import {
  getForgotPasswordUsername,
  setForgotPasswordUsername,
  takeForgotPasswordUsername,
} from "./forgotPasswordSession";
import { resetDefaults } from "../resetPassword/ResetConstant";

const ForgotPasswordLink = ({
  setIsForgotPassword,
  setIsLinkSet,
  initialUsername = "",
  passwordResetRequiredNotice = false,
}) => {
  const [username, setUsername] = useState(
    () => (initialUsername || "").trim() || takeForgotPasswordUsername()
  );
  const [error, setError] = useState(false);
  const [serverErrorMessage, setServerErrorMessage] = useState("");

  const {
    forgotPassword,
    userMessage,
    enterUsername,
    sendPassword,
    returnToLogin,
    emailMessage,
    errorMessage,
  } = defaults;

  const handleResetLinkAction = (e) => {
    e.preventDefault();
    setError(false);
    setServerErrorMessage("");

    if (username !== "") {
      const normalizedUsername = username.toLowerCase().trim();
      superagent
        .post(apiUrl("/auth/password/forgot"))
        .send({ username: normalizedUsername })
        .then((res) => {
          if (res?.body?.message === emailMessage) {
            setForgotPasswordUsername(username);
            setIsLinkSet(true);
          }
        })
        .catch((err) => {
          const apiMessage = err?.response?.body?.error?.message;
          setServerErrorMessage(apiMessage || errorMessage);
        });
    } else setError(true);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <HeaderLogo />
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        data-testid="reset-form-box"
      >
        <Paper
          sx={{
            backgroundColor: "background.primary",
            border: "1px solid var(--elevation-outlined, #FFFFFF1F)",
            color: "text.primary",
            p: 6,
            pb: 4,
            width: 450,
          }}
        >
          <Typography variant="h4" lineHeight="42px" letterSpacing="0.5px">
            {forgotPassword}
          </Typography>
          {passwordResetRequiredNotice && (
            <Alert
              severity="warning"
              variant="outlined"
              sx={{ mt: 3, mb: 1 }}
              data-testid="password-reset-required-alert"
            >
              {resetDefaults.passwordResetRequiredMessage}
            </Alert>
          )}
          <Typography
            variant="body1"
            sx={{
              mt: passwordResetRequiredNotice ? 2 : 3,
              mb: 2,
              lineHeight: "24px",
              letterSpacing: "0.15px",
            }}
          >
            {userMessage}
          </Typography>
          <form method="POST" onSubmit={handleResetLinkAction}>
            <Box sx={{ mb: 4 }}>
              <TextField
                error={error}
                helperText={error ? enterUsername : ""}
                fullWidth
                margin="normal"
                label="Username"
                variant="outlined"
                value={username}
                data-testid="username-field"
                onChange={(e) => {
                  setError(false);
                  setServerErrorMessage("");
                  setUsername(e.target.value);
                }}
              />
            </Box>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              size="large"
              data-testid="send-reset-link-button"
            >
              {sendPassword}
            </Button>
          </form>
          <Box fullWidth textAlign="center" mt={4}>
            <Button
              variant="text"
              color="primary"
              size="large"
              data-testid="return-login-button"
              onClick={() => {
                setForgotPasswordUsername(username);
                setIsForgotPassword(false);
              }}
            >
              {returnToLogin}
            </Button>
            {serverErrorMessage && (
              <Typography color="error">{serverErrorMessage}</Typography>
            )}
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

ForgotPasswordLink.defaultProps = {
  setIsForgotPassword: () => {},
  setIsLinkSet: () => {},
  initialUsername: "",
  passwordResetRequiredNotice: false,
};

ForgotPasswordLink.propTypes = {
  setIsForgotPassword: PropTypes.func,
  setIsLinkSet: PropTypes.func,
  initialUsername: PropTypes.string,
  passwordResetRequiredNotice: PropTypes.bool,
};

export default ForgotPasswordLink;
